import React, { FC, memo } from 'react'
import { IProfessionsListProps } from '../types'
import { ProfessionsListItem } from './ProfessionsListItem'
import SC from '../base/ProfessionsList.styles'

const { Block } = SC

/** Список профессий */
const ProfessionsList: FC<IProfessionsListProps> = (props) => {
  const { items, elements, tagIds } = props

  return (
    <Block>
      {items.map((profession, key) => {
        const element = elements && elements.find((el) => el.key === key)
        const ReactElement = element ? element?.element : null

        return (
          <div key={profession.id}>
            <ProfessionsListItem tagIds={tagIds || profession.tagIds} {...profession} />

            {ReactElement}
          </div>
        )
      })}
    </Block>
  )
}

export { ProfessionsList }
export default memo(ProfessionsList)
